import { createFileRoute } from '@tanstack/react-router'

import { OnboardingWizardPage } from '@/pages/onboarding/OnboardingWizardPage'

export const Route = createFileRoute('/onboarding')({
  component: OnboardingWizardPage,
})
